import tw from 'twin.macro';

export const StyledPopover = tw.div`relative`;
